module.exports = __webpack_public_path__ + "static/media/icon-activites-manuelles.ea38f0e0.svg";